<template>
  <div class="mr15">
    <h4 class="comm_tit02">
      {{ title02 }}
    </h4>
  </div>
</template>

<script>
export default {
  name: 'SampleTab02',
  data() {
    return {
      title02: 'TAB02',
    };
  },
  mounted() {
    console.log(`>>\t${this.title02}`);
  },
  methods: {
    reset() {
      console.log('[SampleTab02] reset() was called.');
      this.title02 = '----- reset02';
      console.log(`>>\t${this.title02}`);
    },
  },
  activated() {
    utils.messageBox('information', '2번탭이 활성화 되었습니다');
  },
  deactivated() {
    utils.messageBox('information', '2번탭이 비활성화 되었습니다');
  }
};
</script>

<style scoped>
</style>
